export const android = [
    {
      content: `Lorem ipsum dolor, sit amet consectetur adipisicing elit. Quis sapiente
      laborum cupiditate possimus labore, hic temporibus velit dicta earum
      suscipit commodi eum enim atque at? Et perspiciatis dolore iure
      voluptatem.`
    }
  ];
  export const flutter = [
    {
      content: `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor 
      incididunt ut labore et dolore magna aliqua. Sagittis purus sit amet volutpat consequat. 
      Quam adipiscing vitae proin sagittis.`
    }
  ];
  export const cloud = [
    {
      content: `Sapiente expedita hic obcaecati, laboriosam similique omnis architecto ducimus magnam accusantium corrupti
      quam sint dolore pariatur perspiciatis, necessitatibus rem vel dignissimos
      dolor ut sequi minus iste? Quas?`
    }
  ];
  export const ui = [
    {
      content: `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore 
      magna aliqua. Tellus rutrum tellus pellentesque eu tincidunt tortor aliquam nulla facilisi. Blandit turpis cursus in hac 
      habitasse platea dictumst quisque.`
    }
  ];
  export const web = [
    {
      content: `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore 
      magna aliqua. Sociis natoque penatibus et magnis dis. Nulla facilisi etiam dignissim diam quis enim lobortis scelerisque. `
    }
  ];